interface IConfigSingleton {
    models: {
        respect: string;
    };
}

export const ConfigSingleton: IConfigSingleton = require('../../../dist/data/config.json');
